/**
 * Three inline glyphs rather than an icon dependency. The booking panel
 * needs exactly these, and a package would cost more than it saves.
 */
interface Props {
  name: 'calendar' | 'clock' | 'desk';
  size?: number;
}

const PATHS: Record<Props['name'], JSX.Element> = {
  calendar: (
    <>
      <rect x="3" y="4.5" width="14" height="12.5" rx="2" />
      <path d="M3 8.5h14M6.5 2.5v3M13.5 2.5v3" />
    </>
  ),
  clock: (
    <>
      <circle cx="10" cy="10" r="7.5" />
      <path d="M10 5.5V10l3 2" />
    </>
  ),
  desk: (
    <>
      <path d="M2.5 8.5h15M4.5 8.5v8M15.5 8.5v8" />
      <path d="M5.5 8.5V5a1.5 1.5 0 0 1 1.5-1.5h6A1.5 1.5 0 0 1 14.5 5v3.5" />
    </>
  ),
};

export function Icon({ name, size = 17 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
